import React, { useContext, useEffect, useState } from 'react';
import GeneralContext from '../Components/GeneralContext/GeneralContext';
import ModalStandard from '../Components/GeneralComponents/ModalStandard';
import DelayedNavigate from './DelayedNavigate'; // <- ajusta la ruta

const ProtectedRoute = ({
  children,
  requiredResource,
  redirectTo = "/home",
  redirectDelay = 5000,
  modalTitle = "Acceso denegado",
  modalMsg,
  btnText = "Ir al inicio",
}) => {
  const { userResources = [], loading } = useContext(GeneralContext);
  const [open, setOpen] = useState(false);

  const hasAccess = requiredResource ? userResources.includes(requiredResource) : true;

  useEffect(() => {
    if (!loading && !hasAccess) setOpen(true);
  }, [loading, hasAccess]);

  if (loading) return null;

  if (!hasAccess) {
    return (
      <>
        <ModalStandard
          open={open}
          onClose={() => setOpen(false)} 
          error
          title={modalTitle}
          msg={modalMsg ?? `No tienes acceso al recurso “${requiredResource}”. Serás redirigido/a al inicio.`}
          btnText={btnText}
          onClick={() => setOpen(false)}           
        />
        <DelayedNavigate to={redirectTo} delay={redirectDelay} state={{ denied: true }} />
      </>
    );
  }

  return children;
};

export default ProtectedRoute;
